import MarketplaceApp from './MarketplaceApp';

export const MarketplaceConfig = {
    routes: [
        {
            path: '/:organizacao/:empresa/marketplace',
            component: MarketplaceApp
        }
    ]
};

